<template>
  <div class="container editInstallation">
    <h1 class="title">
      <span class="icon clickable returnIcon" @click="goBack">
        <i class="mdi mdi-chevron-left"></i>
      </span>
      {{ id ? $t("installation.edit") : $t("installation.add") }}
    </h1>

    <h2 class="subtitle">{{ $t("installation.configure") }}</h2>

    <div class="columns">
      <div class="column">
        <b-field :label="$t('installation.name')">
          <b-input v-model="form.name"></b-input>
        </b-field>
        <b-field :label="$t('installation.location')">
          <b-input v-model="form.location"></b-input>
        </b-field>

        <b-field class="file">
          <b-upload v-model="file">
            <a class="button is-primary">
              <b-icon icon="upload"></b-icon>
              <span>{{ $t("installation.image") }}</span>
            </a>
          </b-upload>
          <span class="file-name" v-if="file">
            {{ file[0].name }}
          </span>
        </b-field>
      </div>
      <div class="column">
        <b-field :label="$t('installation.timeZone')">
          <b-select
            @input="loadOffset"
            :placeholder="$t('form.select')"
            v-model="form.timeZoneId"
          >
            <option
              v-for="zone in timeZones"
              :key="zone.value"
              :value="zone.value"
            >
              {{ zone.text }}
            </option>
          </b-select>
        </b-field>
        <b-field :label="$t('installation.currency')">
          <b-select :placeholder="$t('form.select')" v-model="form.currency">
            <option value="GBP">{{ $t("currency.gbp") }}</option>
            <option value="USD">{{ $t("currency.usd") }}</option>
            <option value="EUR">{{ $t("currency.eur") }}</option>
            <option value="RUB">{{ $t("currency.rub") }}</option>
          </b-select>
        </b-field>

        <b-field :label="$t('installation.map')">
          <button
            v-if="!showMap"
            class="button is-success"
            @click="showMap = true"
          >
            {{ $t("installation.showMap") }}
          </button>
          <button v-else class="button is-success" @click="showMap = false">
            {{ $t("installation.closeMap") }}
          </button>
        </b-field>

        <div v-if="showMap">
          <b-field :label="$t('installation.searchAddress')">
            <b-input v-model="locationSearch"></b-input>
          </b-field>

          <div style="text-align: center">
            <small>{{ $t("installation.clickToChoseLocation") }}</small>
          </div>

          <br />

          <GmapMap
            @click="dealMapClick"
            :center="{ lat: lat, lng: lng }"
            :zoom="13"
            style="width: 500px; height: 300px; margin: 0 auto"
          >
            <GmapMarker
              v-if="this.form.latitude && this.form.longitude"
              :position="{ lat: this.form.latitude, lng: this.form.longitude }"
            ></GmapMarker>
          </GmapMap>

          <b-field style="text-align: center"> </b-field>
        </div>
      </div>
    </div>

    <br /><br />

    <button
      class="button is-success"
      :disabled="!isInstallationValid"
      @click="saveInstallation"
    >
      {{ $t("buttons.save") }}
    </button>
  </div>
</template>

<script>
/* eslint-disable */

import { mapState, mapActions } from "vuex";
import BField from "../../../../node_modules/buefy/src/components/field/Field";
import { EventBus } from "../../../util/event-bus";
import * as timezones from "../../../util/timezones.json";

export default {
  components: { BField },
  name: "installation-wizard",
  props: {
    id: String,
  },
  data() {
    return {
      showMap: false,
      locationSearch: "",
      lat: 10,
      lng: 10,
      form: {
        name: "",
        location: "",
        timeZone: "",
        timeZoneId: "",
        latitude: "",
        longitude: "",
        currency: "",
      },
      file: null,
    };
  },

  computed: {
    ...mapState("user", {
      user: "current",
    }),

    ...mapState("installations", {
      installation: "current",
    }),

    timeZones: function () {
      return timezones.default;
    },

    isInstallationValid: function () {
      return (
        Object.values(this.form).filter(
          (field) => typeof field === "string" && field.length === 0
        ).length === 0
      );
    },
  },

  methods: {
    ...mapActions("installations", {
      setInstallation: "setCurrent",
      createInstallation: "createInstallation",
      updateInstallation: "updateInstallation",
      uploadImage: "uploadImage",
    }),

    loadOffset: function (timeZone) {
      let tz = this.timeZones.find((tz) => tz.value === timeZone);
      let offset = tz.offset;

      if (tz.isdst) offset--;
      this.form.timeZone = offset;
    },

    dealMapClick: function (event) {
      let latitude = event.latLng.lat();
      let longitude = event.latLng.lng();
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        { location: { lat: latitude, lng: longitude } },
        (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results.length > 0) {
              let postal_code = "";
              let state = "";
              let city = "";

              results.forEach((result) => {
                result.address_components.forEach((component) => {
                  component.types.forEach((type) => {
                    switch (type) {
                      case "postal_code":
                        postal_code = component.long_name;
                        break;
                      case "administrative_area_level_1":
                        state = component.long_name;
                        break;
                      case "locality":
                        city = component.long_name;
                        break;
                    }
                  });
                });
              });

              let location = postal_code;
              if (city.length > 0) location += ", " + city;
              if (state.length > 0) location += ", " + state;

              this.form.location = location;
              this.form.latitude = latitude;
              this.form.longitude = longitude;
            }
          }
        }
      );
    },

    loadForm: function () {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = this.installation[key];
      });
    },

    goBack: function () {
      this.$router.push("/installations/" + this.installation[".key"]);
    },

    saveInstallation: function () {
      let afterSave = () => {
        if (this.file) {
          EventBus.$emit("showLoading");

          this.uploadImage({
            installation: this.installation,
            file: this.file[0],
          }).then(() => {
            EventBus.$emit("hideLoading");
            this.goBack();
          });
        } else this.goBack();
      };

      if (this.id) {
        //UPDATE
        this.updateInstallation({
          installation: this.installation,
          form: this.form,
        }).then(() => afterSave());
      } else {
        //CREATE
        this.createInstallation(this.form).then((id) => {
          this.setInstallation(id).then(() => afterSave());
        });
      }
    },
  },

  watch: {
    locationSearch: function () {
      if (this.locationSearch.length <= 1) return false;
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: this.locationSearch }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          this.lat = results[0].geometry.location.lat();
          this.lng = results[0].geometry.location.lng();
        }
      });
    },
  },

  mounted() {
    if (this.id) {
      this.setInstallation(this.id)
        .then(() => {
          this.loadForm();
        })
        .catch(() => {
          this.$router.push("/installations");
        });
    }

    navigator.geolocation.getCurrentPosition((location) => {
      this.lat = location.coords.latitude;
      this.lng = location.coords.longitude;
    });
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 100%;
}

.editInstallation {
  padding: 0 2rem 2rem;
}

h1.title {
  margin: 3rem 0 5rem;
}
</style>
